import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { connect } from 'react-redux';
import omit from 'lodash.omit';

import withModal from '../../../../components/global/modal/withModal';
import { UPDATE_ROSTER_IDENTITY_MODAL } from '../../../../constants/modals';
import { MeQuery } from '../../../../graphql/queries/account';
import RosterIdentityUpdate from './RosterIdentityUpdate';
import { photoUploadSuccess } from '../../../../actions/photo-upload';

const propTypes = {
  actionProps: PropTypes.shape({
    rosterIdentity: PropTypes.shape({
      id: PropTypes.string,
    }),
    identityId: PropTypes.string,
    onRosterIdentityCreated: PropTypes.func,
    onRosterIdentityUpdated: PropTypes.func,
    defaultEditAddress: PropTypes.bool,
    albumId: PropTypes.string,
    isSubscription: PropTypes.bool,
  }),
};

const RosterIdentityUpdateContainer = ({
  actionProps: {
    rosterIdentity,
    identityId,
    onRosterIdentityCreated,
    onRosterIdentityUpdated,
    defaultEditAddress,
    albumId,
    albumFolderId,
    albumFolderSelectionEnabled,
    albumSelectionEnabled,
    isSubscription,
  } = {},
  ...props
}) => (
  <RosterIdentityUpdate
    rosterIdentity={rosterIdentity}
    identityId={identityId}
    defaultEditAddress={defaultEditAddress}
    albumId={albumId}
    onRosterIdentityCreated={onRosterIdentityCreated}
    onRosterIdentityUpdated={onRosterIdentityUpdated}
    albumFolderId={albumFolderId}
    albumFolderSelectionEnabled={albumFolderSelectionEnabled}
    albumSelectionEnabled={albumSelectionEnabled}
    isSubscription={isSubscription}
    {...omit(props, 'actionProps')}
  />
);

RosterIdentityUpdateContainer.propTypes = propTypes;

const withUserData = graphql(MeQuery, {
  props: ({ data: { me } }) => ({
    account: me,
  }),
});

const mapDispatchToProps = {
  photoUploadSuccess,
};

export default withModal(
  compose(
    withUserData,
    connect(null, mapDispatchToProps),
  )(RosterIdentityUpdateContainer),
  {
    name: UPDATE_ROSTER_IDENTITY_MODAL,
    contentLabel: 'Update Member',
    size: 'md',
    type: 'full',
    shouldCloseOnOverlayClick: false,
  },
);
